import TreeSelectionList from './TreeSelectionList';
import { withTranslation } from '../Translator';

const TranslatedTreeSelectionList = withTranslation('components')(TreeSelectionList);

export default TranslatedTreeSelectionList;
